// Program messages carry one of two schedules: N days after the program start,
// or N days before the program end. Both are projected onto "days after program
// start" so messages using different anchors can be ordered against each other.

const toDays = (value) => {
  const days = Number(value);
  return Number.isNaN(days) ? null : days;
};

// `programLength` is an inclusive day count (Aug 1 - Aug 10 is 10), so the final
// day of the program sits at offset programLength - 1.
export function messageSendOffsetDays(message, programLength) {
  if (message?.numDaysToProgramEnd != null) {
    const days = toDays(message.numDaysToProgramEnd);
    if (days == null || programLength == null) return null;
    return programLength - 1 - days;
  }
  if (message?.numDaysAfterProgramStart != null) {
    return toDays(message.numDaysAfterProgramStart);
  }
  return null;
}

// Chronological order for the messages list and its sidebar substeps. Messages
// with no resolvable send date — incomplete, or anchored to an end date the
// program doesn't have yet — hold their relative order at the end of the list.
export function sortMessagesBySendDate(messages, programLength) {
  return (messages || [])
    .map((message, index) => ({
      message,
      index,
      offset: messageSendOffsetDays(message, programLength),
    }))
    .sort((a, b) => {
      if (a.offset == null || b.offset == null) {
        if (a.offset == null && b.offset == null) return a.index - b.index;
        return a.offset == null ? 1 : -1;
      }
      return a.offset - b.offset || a.index - b.index;
    })
    .map(({ message }) => message);
}
